import Vue from 'vue'

// Общий плеер админки. Один объект Audio живёт на уровне модуля, а не
// компонента: звук не обрывается ни при переходе между страницами, ни при
// перерисовке шапки, а слушатели событий вешаются ровно один раз.

// current — описание играющего трека:
// { key, url, title, artist, sourceLabel, link, details, hint }
export const globalPlayer = Vue.observable({
  current: null,
  isPlaying: false,
  currentTime: 0,
  duration: 0,
  error: '',
})

const audio = new Audio()
audio.preload = 'metadata'

audio.addEventListener('timeupdate', () => {
  globalPlayer.currentTime = audio.currentTime
})

// У mp3 с переменным битрейтом браузер уточняет длительность позже
// событием durationchange — слушаем оба события одним и тем же обработчиком
const updateDuration = () => {
  globalPlayer.duration = Number.isFinite(audio.duration) ? audio.duration : 0
}

audio.addEventListener('loadedmetadata', updateDuration)
audio.addEventListener('durationchange', updateDuration)

audio.addEventListener('play', () => {
  globalPlayer.isPlaying = true
})

audio.addEventListener('pause', () => {
  globalPlayer.isPlaying = false
})

audio.addEventListener('ended', () => {
  globalPlayer.isPlaying = false
})

audio.addEventListener('error', () => {
  // Сброс источника в closePlayer() тоже может породить error — это не сбой
  if (!globalPlayer.current) return

  globalPlayer.isPlaying = false
  globalPlayer.error = 'Не удалось загрузить файл'
})

const startPlayback = () => {
  audio.play().catch(error => {
    // Запуск прерван загрузкой следующего трека — это не ошибка
    if (error && error.name === 'AbortError') return

    globalPlayer.isPlaying = false
    globalPlayer.error = 'Не удалось воспроизвести файл'
  })
}

// Тот же трек (совпадают ключ и адрес) ставится на паузу или продолжается с той
// же позиции; любой другой загружается и запускается с начала.
export const toggleTrack = descriptor => {
  const current = globalPlayer.current
  const isSameTrack = current && current.key === descriptor.key && current.url === descriptor.url

  if (isSameTrack) {
    if (globalPlayer.error) {
      // После сбоя audio.paused может остаться false (play() уже успел его
      // выставить до отказа), поэтому решаем не по нему: сбрасываем ошибку,
      // перезапрашиваем источник и запускаем воспроизведение заново
      globalPlayer.error = ''
      audio.load()
      startPlayback()
    } else if (globalPlayer.isPlaying) {
      audio.pause()
    } else {
      startPlayback()
    }

    return
  }

  globalPlayer.current = descriptor
  globalPlayer.currentTime = 0
  globalPlayer.duration = 0
  globalPlayer.error = ''
  audio.src = descriptor.url
  startPlayback()
}

export const isTrackPlaying = key => Boolean(
  globalPlayer.current && globalPlayer.current.key === key && globalPlayer.isPlaying,
)

export const seekTo = seconds => {
  if (!globalPlayer.current) return

  audio.currentTime = seconds
  globalPlayer.currentTime = seconds
}

export const closePlayer = () => {
  // current обнуляется первым: так слушатель error проигнорирует сброс источника
  globalPlayer.current = null
  audio.pause()
  audio.removeAttribute('src')
  audio.load()
  globalPlayer.isPlaying = false
  globalPlayer.currentTime = 0
  globalPlayer.duration = 0
  globalPlayer.error = ''
}
